import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardHeader, CardBody } from '../components/ui/Card';
import { CtaSection } from '../components/sections/CtaSection';
import { CalendarIcon, MessageSquareIcon, FileTextIcon } from 'lucide-react';
export function Contact() {
  return <div className="pt-20 bg-[#F4E8D0]/30" data-id="element-1149">
      {/* Hero */}
      <section className="bg-[#0099A1] py-20" data-id="element-1150">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1151">
          <div className="max-w-3xl" data-id="element-1152">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-1153">
              Contact Us
            </h1>
            <p className="text-xl text-white/90" data-id="element-1154">
              Ready to go from boardroom to beach? Let's start planning your
              exceptional event.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Options */}
      <section className="py-16 bg-white" data-id="element-1155">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1156">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1157">
            <h2 className="text-3xl font-bold text-[#374047] mb-4" data-id="element-1158">
              Get in Touch
            </h2>
            <p className="text-lg text-[#374047]/80" data-id="element-1159">
              Choose the method that works best for you. Our team is ready to
              help plan your perfect event.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16 max-w-4xl mx-auto" data-id="element-1160">
            <Card className="text-center h-full" data-id="element-1161">
              <CardHeader className="flex flex-col items-center" data-id="element-1162">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#0099A1]/10 mb-4" data-id="element-1163">
                  <CalendarIcon className="h-8 w-8 text-[#0099A1]" data-id="element-1164" />
                </div>
                <h3 className="text-xl font-bold text-[#374047]" data-id="element-1165">
                  Book a Call
                </h3>
              </CardHeader>
              <CardBody data-id="element-1166">
                <p className="text-[#374047]/80 mb-6" data-id="element-1167">
                  Schedule a 15-minute discovery call with our team to discuss
                  your event needs.
                </p>
                <Button variant="primary" href="https://calendar.app.google/FGeh6NzZCtuDUMjV9" target="_blank" rel="noopener noreferrer" data-id="element-1168">
                  Book Discovery Call
                </Button>
              </CardBody>
            </Card>
            <Card className="text-center h-full" data-id="element-1169">
              <CardHeader className="flex flex-col items-center" data-id="element-1170">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#0099A1]/10 mb-4" data-id="element-1171">
                  <MessageSquareIcon className="h-8 w-8 text-[#0099A1]" data-id="element-1172" />
                </div>
                <h3 className="text-xl font-bold text-[#374047]" data-id="element-1173">WhatsApp</h3>
              </CardHeader>
              <CardBody data-id="element-1174">
                <p className="text-[#374047]/80 mb-6" data-id="element-1175">
                  Connect with us instantly via WhatsApp for quick questions and
                  inquiries.
                </p>
                <Button variant="outline" className="bg-[#25D366] text-white border-[#25D366] hover:bg-[#25D366]/90" href="https://api.whatsapp.com/send?phone=19052152109" target="_blank" rel="noopener noreferrer" data-id="element-1176">
                  Start WhatsApp Chat
                </Button>
              </CardBody>
            </Card>
            <Card className="text-center h-full" data-id="element-1177">
              <CardHeader className="flex flex-col items-center" data-id="element-1178">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#0099A1]/10 mb-4" data-id="element-1179">
                  <FileTextIcon className="h-8 w-8 text-[#0099A1]" data-id="element-1180" />
                </div>
                <h3 className="text-xl font-bold text-[#374047]" data-id="element-1181">
                  Request Proposal
                </h3>
              </CardHeader>
              <CardBody data-id="element-1182">
                <p className="text-[#374047]/80 mb-6" data-id="element-1183">
                  Fill out our detailed form and we'll create a custom plan for
                  your event.
                </p>
                <Button variant="primary" href="https://form.typeform.com/to/QUkK2HU7" target="_blank" rel="noopener noreferrer" data-id="element-1184">
                  Book Discovery Call
                </Button>
              </CardBody>
            </Card>
          </div>
        </div>
      </section>

      <CtaSection data-id="element-1185" />
    </div>;
}